import styled from 'styled-components';

export const CoverContainer = styled.div`
  position: relative;
  width: 100%;
  height: clamp(180px, 30vw, 350px);
  z-index: 1;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  border-radius: 1rem;
  border: 4px solid white;
  margin-top: 1.5rem;

  @media (max-width: 767px) {
    border-radius: 0;
    border: none;
    box-shadow: none;
    margin-top: 0;
  }
`;

export const CoverImage = styled.div<{ backgroundImage: string }>`
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  overflow: hidden;
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;

  @media (max-width: 767px) {
    border-radius: 0;
  }
`;

export const LogoImage = styled.div<{ logo: string }>`
  position: absolute;
  background-color: white;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075);
  border-radius: 0.5rem;
  border: 4px solid white;
  width: clamp(100px, 15vw, 130px);
  height: clamp(100px, 15vw, 130px);
  bottom: calc(-1 * clamp(50px, 7.5vw, 65px));
  background-image: url(${props => props.logo});
  background-size: cover;
  background-position: center;
  z-index: 3;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 768px) {
    left: 1rem;
    transform: none;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: center;
  padding: 0 0.5rem;
  margin-top: 3rem;
  z-index: 2;

  @media (min-width: 768px) {
    text-align: left;
    margin-top: 0.5rem !important;
    padding-left: clamp(140px, 18vw, 160px) !important;
    padding-right: 1rem;
    gap: 0.5rem;
  }
`;

export const BadgesWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  width: 100%;

  @media (min-width: 768px) {
    justify-content: flex-start;
    align-items: center;
  }
`;

export const CashbackBadge = styled.div<{ primaryColor?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0 .125rem .5rem rgba(0,0,0,.05);
  background-color: white;
  border: 1px solid #edf2f7;
  border-left: 4px solid #27ae60;
  font-size: 0.85rem;
  
  .cashback-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .cashback-icon {
    color: #27ae60;
    font-size: 1.25rem;
  }
  
  .cashback-content {
    display: flex;
    flex-direction: column;
  }
  
  .cashback-title {
    font-weight: 700;
    color: #2d3748;
    font-size: 1rem;
    line-height: 1.2;
  }
  
  .cashback-text {
    color: #4a5568;
    font-size: 0.85rem;
    line-height: 1.4;
  }
  
  .cashback-link {
    font-weight: 700;
    text-decoration: none;
    color: #27ae60;
    font-size: 0.9rem;
    margin-top: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    border: 1px solid #27ae60;
    border-radius: 0.5rem;
    transition: all 0.2s;
    
    &:hover {
      background-color: #27ae60;
      color: white !important;
      text-decoration: none;
    }
  }

  @media (min-width: 768px) {
    padding: 1rem;
    margin-top: 0.5rem;
    
    .cashback-header {
      margin-bottom: 0.5rem;
    }
    
    .cashback-icon {
      font-size: 1.25rem;
    }
    
    .cashback-title {
      font-size: 1rem;
    }
    
    .cashback-text {
      font-size: 0.85rem;
    }
  }
`;

export const StatusBadge = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.75rem;
  border-radius: 50rem;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.05);
  background-color: white;
  border: 1px solid #eee;
  font-size: 0.8rem;
  flex: 0 1 auto;
  white-space: nowrap;

  .status-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: ${props => props.isOpen ? '#38a169' : '#e53e3e'};
    box-shadow: 0 0 4px ${props => props.isOpen ? '#38a16980' : '#e53e3e80'};
  }

  .status-text {
    font-weight: 600;
    color: ${props => props.isOpen ? '#2f855a' : '#c53030'};
  }

  @media (min-width: 768px) {
    padding: 0.25rem 1rem;
    font-size: 0.9rem;
    gap: 0.5rem;
    
    .status-indicator {
      width: 10px;
      height: 10px;
    }
  }
`;

export const InfoBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.75rem;
  border-radius: 50rem;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.05);
  background-color: white;
  border: 1px solid #eee;
  font-size: 0.8rem;
  flex: 0 1 auto;
  white-space: nowrap;

  @media (min-width: 768px) {
    padding: 0.25rem 1rem;
    font-size: 0.9rem;
    gap: 0.5rem;
  }
`;

export const InfoButton = styled.button<{ primaryColor?: string }>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.75rem;
  border-radius: 50rem;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.05);
  background-color: white;
  border: 1px solid #eee;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.8rem;
  color: ${props => props.primaryColor || '#e74c3c'};
  transition: all 0.2s ease-in-out;
  flex: 0 1 auto;
  white-space: nowrap;

  &:hover {
    background-color: #f8f9fa;
  }

  @media (min-width: 768px) {
    padding: 0.25rem 1rem;
    font-size: 0.9rem;
    gap: 0.5rem;
  }
`;
